/**
 * Derive Employee Insights pending assignee from policy workflow steps.
 */
const ROLE_LABELS = {
  manager: "Manager",
  hr: "HR",
  management: "Management",
  reporting_manager: "Reporting Manager",
  MANAGER: "Manager",
  HR: "HR",
  ADMIN: "Admin",
};

export function resolveFirstWorkflowPendingRole(policy) {
  if (!policy || policy.approvalMethod !== "workflow") return "Approver";
  const steps = Array.isArray(policy.workflowSteps) ? policy.workflowSteps : [];
  const firstApproval = steps.find((s) => !s.notifyOnly);
  const firstStep = firstApproval || steps[0];
  if (!firstStep?.role) return "Approver";
  return ROLE_LABELS[firstStep.role] || String(firstStep.role);
}

export function buildPolicyInsightEntry({ action, employee, policy, status = "Pending" }) {
  const employeeName =
    employee?.name || employee?.user?.name || employee?.full_name || employee?.empName || "Employee";
  const employeeCode = employee?.empCode || employee?.emp_code || employee?.employeeCode || "";
  const submittedAt = new Date().toLocaleString();
  const pendingWith = resolveFirstWorkflowPendingRole(policy);

  return {
    id: `${Date.now()}_${Math.random().toString(16).slice(2)}`,
    action,
    employeeCode: employeeCode || "-",
    employeeName: employeeCode ? employeeName : "-",
    employee: employeeCode ? `${employeeName} (${employeeCode})` : employeeName,
    pendingWith,
    pendingAt: submittedAt,
    submittedAt,
    status,
    approvedBy: "-",
    when: "-",
    policyId: policy?.id,
    policyName: policy?.policyName || policy?.name,
  };
}
